import { fromZonedTime, toZonedTime } from 'date-fns-tz';

type TimeZoneDateInput = {
  year?: number;
  month?: number;
  day?: number;
  hour?: number;
  minute?: number;
  timeZone: string;
};

export const getDateFromDateInTimeZone = ({ year, month, day, hour, minute, timeZone }: TimeZoneDateInput) => {
  const today = toZonedTime(new Date(), timeZone);

  if (isNaN(today.getTime())) {
    return undefined;
  }

  const date = fromZonedTime(
    new Date(
      year ?? today.getFullYear(),
      month ?? today.getMonth(),
      day ?? today.getDate(),
      hour ?? today.getHours(),
      minute ?? today.getMinutes()
    ),
    timeZone
  );

  if (isNaN(date.getTime())) {
    return undefined;
  }

  return date;
};
